import { FullWidthPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

const NotFound = () => {
  const { formatMessage } = useContent()
  return (
    <FullWidthPage
      heading={formatMessage({ id: 'pmportal.error.pageNotFound' })}
      subheading={formatMessage({
        id: 'pmportal.error.pageNotFoundDescription',
      })}
    />
  )
}

export default NotFound
